"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentItem = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const constant_1 = require("../../constant");
const function_1 = require("../../function");
const DeleteListBtn_1 = require("./DeleteListBtn");
const getStatusColor = status => {
    if (status === 'closed')
        return Colors_1.Colors.black;
    if (status === 'open')
        return Colors_1.Colors.tur;
    return Colors_1.Colors.pink;
};
const getStatusColorClass = status => {
    if (status === 'closed')
        return 'btn_line_light_grey';
    if (status === 'open')
        return 'btn_pink';
    return 'btn_line_blue';
};
// 날짜 포맷을 변수로 선언
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD, HH:mm';
const progressPeriodDateTimeFormat = 'YYYY-MM-DD HH:mm';
exports.AssignmentItem = react_1.default.memo(({ headItem, item, isHome, isTest, isSurvey, isMobile, isTablet, isTeacher, isBackOffice, styles, handlerEdit, handlerGradeReport, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const isTeacherTestListView = isTeacher && isTest && !isHome && !isMobile && !isBackOffice;
    const getProgressPeriodText = () => {
        const start = (0, moment_1.default)(item.startline);
        // startline 미설정/zero-date(0001, 서버 시간 처리 전)면 진행기간 미정 → '-'
        if (!item.startline || !start.isValid() || start.year() <= 1)
            return '-';
        const end = (0, moment_1.default)(item.deadline);
        // deadline 미설정/zero-date(0001-01-01, 강의 연동 전)면 종료 생략하고 시작만 표시
        const endMissing = !item.deadline || !end.isValid() || end.year() <= 1;
        if (endMissing) {
            return start.format(progressPeriodDateTimeFormat);
        }
        if (start.format(dateFormat) === end.format(dateFormat)) {
            return `${start.format(progressPeriodDateTimeFormat)} ~ ${end.format('HH:mm')}`;
        }
        return `${start.format(progressPeriodDateTimeFormat)} ~ ${end.format(progressPeriodDateTimeFormat)}`;
    };
    // 공통적으로 사용될 스타일 선언
    const commonTextStyle = styles?.bodyText;
    // 서버 status가 현재 시각과 어긋날 수 있어, 시작일/마감일 기준으로 진행상태 재계산
    // (created/open/closed 만 재계산, hide/booked 등 특수상태는 그대로 보존)
    const actualStatus = (0, function_1.calculateActualStatus)(item);
    // 출제유형 표시: 설문조사(survey:true)는 서버 type이 '설문형'이라도 '설문조사'로 표기
    const questionTypeLabel = item.survey ? '설문조사' : item.type;
    switch (headItem.title) {
        case 'mobile':
            return (react_1.default.createElement("div", { className: "mobile-contents" },
                !isMobile && !isSurvey && (react_1.default.createElement("div", { className: "mobile-assignment" },
                    react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xxs", text: t(`assignment.${actualStatus}`) }),
                    react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xxs", text: questionTypeLabel }))),
                react_1.default.createElement("div", { className: "contents" }, item.title),
                react_1.default.createElement("div", { className: "divier" }),
                react_1.default.createElement("div", { className: "bottom" },
                    isTest && (react_1.default.createElement("div", { className: "class-name" },
                        "\uC218\uC5C5\uBA85 - ",
                        item.conference_name)),
                    !isTest ? (react_1.default.createElement("div", { className: "date" },
                        react_1.default.createElement("p", null,
                            "\uC2DC\uC791\uC77C : ",
                            (0, moment_1.default)(item.startline).format(dateTimeFormat)),
                        react_1.default.createElement("p", null,
                            "\uB9C8\uAC10\uC77C : ",
                            (0, moment_1.default)(item.deadline).format(dateTimeFormat)))) : (react_1.default.createElement("div", { className: "date" },
                        react_1.default.createElement("p", null,
                            "\uC9C4\uD589 \uAE30\uAC04 : ",
                            getProgressPeriodText()),
                        react_1.default.createElement("p", null,
                            "\uD480\uC774\uC2DC\uAC04 : ",
                            t('assignment.minutes', { minute: item.duration })))))));
        case 'manage':
        case 'etc': {
            const gmkAndYigam = item.report_type === 'gmk' || item.report_type === 'yigam';
            // p.44: 진행상태와 무관하게 성적표 등록 버튼 노출 (종료 조건 제거)
            const shouldShowGradeReport = isMobile && isTeacher && isTest && !isHome && gmkAndYigam;
            return (react_1.default.createElement("div", { className: "flex row", style: {
                    gap: 10,
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                } },
                isMobile && (react_1.default.createElement("div", { className: "flex row mobile-assignment", style: { gap: 10 } },
                    react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xxs", text: t(`assignment.${actualStatus}`) }),
                    !isSurvey && react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xxs", text: item.report_name }),
                    shouldShowGradeReport && (react_1.default.createElement(common_1.Button, { className: "btn_default mobile-xxs", onClick: handlerGradeReport, text: (0, function_1.isGradeDataEntered)(item) ? '등록 완료' : '등록하기' })))),
                isTeacher && (react_1.default.createElement("div", { className: "flex row", style: { gap: 10 } },
                    (isBackOffice || item.status == constant_1.TEST_STATUS.CREATED) && (react_1.default.createElement(common_1.Button, { option: {
                            buttonAfterIcon: {
                                show: true,
                                name: 'edit',
                                color: Colors_1.Colors.tur,
                                size: 20,
                            },
                        }, onClick: () => handlerEdit(item.id) })),
                    react_1.default.createElement(DeleteListBtn_1.DeleteListBtn, { isTest: isTest, isOneDel: true, deleteList: [item.id], isBackOffice: isBackOffice })))));
        }
        case 'statusAndTitle':
            return (react_1.default.createElement("div", { className: "contents" },
                react_1.default.createElement(common_1.Button, { className: `${getStatusColorClass(actualStatus)} status-display`, text: t(`assignment.${actualStatus}`) }),
                react_1.default.createElement("p", { className: "name" }, item.title)));
        case 'type_and_subject_name':
        case 'type_and_test_name':
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, questionTypeLabel),
                react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, item.title)));
        case 'submitDate':
            const diffTime = isHome ? (0, moment_1.default)(item.deadline).diff((0, moment_1.default)(), 'days') : 0;
            return (react_1.default.createElement("p", { className: "overText2", style: {
                    color: diffTime > 0
                        ? Colors_1.Colors.black
                        : diffTime === 0
                            ? Colors_1.Colors.tur
                            : Colors_1.Colors.pink,
                } }, diffTime > 0
                ? `D-${diffTime}`
                : diffTime === 0
                    ? 'D-Day'
                    : t('assignment.end')));
        case 'status':
            return (react_1.default.createElement("p", { className: "overText2", style: {
                    color: isBackOffice ? 'black' : getStatusColor(actualStatus),
                } }, isBackOffice
                ? item.status === 'hide'
                    ? '비공개'
                    : '공개'
                : t(`assignment.${actualStatus}${isHome ? 'Home' : ''}`)));
        case 'startline':
            return (!isMobile && (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, (0, moment_1.default)(item[headItem.title]).format(dateTimeFormat))));
        case 'deadline':
            if (isMobile) {
                //모바일 화면에서 사용할 시작일, 상태 값
                const startline = (0, moment_1.default)(item.startline).format(dateTimeFormat);
                if (isTeacher) {
                    return (react_1.default.createElement("div", { className: "date-wrap-mobile" },
                        react_1.default.createElement("p", null,
                            startline,
                            " ~"),
                        react_1.default.createElement("p", null, (0, moment_1.default)(item[headItem.title]).format(dateTimeFormat))));
                }
                else {
                    return (react_1.default.createElement("div", { className: "date-wrap-mobile" },
                        react_1.default.createElement("p", null,
                            t('assignment.startDate'),
                            " : ",
                            startline),
                        react_1.default.createElement("p", null,
                            t('assignment.endDate'),
                            " :",
                            (0, moment_1.default)(item[headItem.title]).format(dateTimeFormat))));
                }
            }
            else {
                return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, (0, moment_1.default)(item[headItem.title]).format(dateTimeFormat)));
            }
        case 'duration':
            return isMobile ? (react_1.default.createElement("div", { className: "status-wrap-mobile" },
                react_1.default.createElement("div", { className: "status-text" },
                    t('assignment.startDate'),
                    " :",
                    (0, moment_1.default)(item.startline).format(dateFormat),
                    ","),
                react_1.default.createElement("div", { className: "status-text" }, t('assignment.minutes', { minute: item[headItem.title] })))) : (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, t('assignment.minutes', { minute: item[headItem.title] })));
        case 'author_name':
            return isMobile ? (isTeacher ? (react_1.default.createElement("div", { className: "status-wrap-mobile" },
                react_1.default.createElement("p", { className: "status-text", style: commonTextStyle }, (0, moment_1.default)(item['headItem.title']).format(dateFormat)),
                react_1.default.createElement("p", { className: "status-text" }, item[headItem.title]))) : (react_1.default.createElement("div", { className: "status-wrap-mobile" },
                react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, t(`assignment.${actualStatus}`)),
                react_1.default.createElement("p", { className: "status-text" }, item[headItem.title])))) : (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, item[headItem.title]));
        case 'title':
        case 'survey_title':
        case 'test_name':
            return isMobile ? (react_1.default.createElement("div", { className: "status-wrap-mobile" },
                !isHome && (react_1.default.createElement(common_1.Button, { className: "btn_tur mobile-xxs", text: t(`assignment.${actualStatus}`) })),
                react_1.default.createElement("p", { className: "title-text-mobile overText2", style: commonTextStyle }, item.title))) : (react_1.default.createElement("p", { className: `overText2 ${isTeacherTestListView ? 'underline_black' : ''}`, style: commonTextStyle }, item.title));
        case 'progress_period':
            return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, getProgressPeriodText()));
        case 'solve_time':
            // 풀이시간 = 배정된 duration(분) 적용. duration 표기와 동일 포맷.
            return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, t('assignment.minutes', { minute: item.duration })));
        case 'report_name':
            return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, item.report_name ?? '-'));
        case 'grade_report': {
            // p.44: 진행상태와 무관하게 성적표 값 표시 (성적 데이터는 진행중에도 등록 가능)
            const gmkAndYigam = item.report_type === 'gmk' || item.report_type === 'yigam';
            if (!gmkAndYigam) {
                // gmk/yigam 외 유형은 성적 데이터 관리 미지원 → 빈 셀 대신 '-' 표시
                return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, "-"));
            }
            return (react_1.default.createElement("p", { className: "overText2 underline_black", style: commonTextStyle }, (0, function_1.isGradeDataEntered)(item) ? '등록 완료' : '등록하기'));
        }
        case 'type':
            return !isHome && isTablet ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: "typeText", style: commonTextStyle }, questionTypeLabel),
                react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, item['title']))) : !isHome && !isTeacher && isMobile ? (react_1.default.createElement("div", { className: "status-wrap-mobile" },
                react_1.default.createElement("p", { className: "typeText", style: commonTextStyle }, questionTypeLabel))) : (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, questionTypeLabel));
        default:
            const content = headItem.title === 'creation_time'
                ? (0, moment_1.default)(item[headItem.title]).format(dateFormat)
                : headItem.title === 'progressdate'
                    ? (0, moment_1.default)(item.startline).format(dateFormat)
                    : headItem.title === 'duration'
                        ? t('assignment.minutes', { minute: item[headItem.title] })
                        : item[headItem.title];
            return (react_1.default.createElement("p", { className: "overText2", style: commonTextStyle }, content));
    }
});
